import React from 'react';
// import CV from '../../assets/cv_meri_gogichashvili.pdf';
import {useContext} from 'react'
import {UserContext} from '../../App'
const CTA = () => {
  const value = useContext(UserContext);
  return (
    <div className="cta">
      <a href= {value?.profile_url? value.profile_url: 'https://amit-portfolio.s3.ap-south-1.amazonaws.com/resume/1673723667_99.Amit%27s%20Resume%20%281%29'} download className="btn">
        Download CV
      </a>
      <a href="#contact" className="btn btn-primary">
        Let's talk
      </a>
    </div>
  );
};

export default CTA;
